import { Button, Text } from 'components/ui';
import UpdateListingVisibilityDialog from 'components/update-listing-visibility-dialog/update-listing-visibility-dialog';
import { useDialogToggle } from 'hooks/use-dialog-toggle';
import {
  ListingRead,
  PublicStatusEnum,
  VisibilityEnum,
} from 'lib/api/generated';
import { getListOfNetworks } from 'lib/marketplace-utils';
import { useMedia } from 'react-use';
import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';
import { globalTheme } from 'styles/global-theme';

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: ${globalTheme.space[2]} 80px;
  gap: ${globalTheme.space[1]};
  background: ${globalTheme.colors.lightPink};
  button {
    width: max-content;
  }
`;

const ListingWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ListedList = styled.ul`
  margin-left: ${globalTheme.space[5]};
`;

interface ListingActionProps {
  listingDetails: ListingRead;
}

function ListingAction({ listingDetails }: ListingActionProps) {
  const [
    isListingVisibilityOpen,
    openListingVisibilityDialog,
    closeListingVisibilityDialog,
  ] = useDialogToggle(false);

  const isMobile = useMedia(`(max-width: ${breakpoints.medium})`, false);
  if (!isMobile) {
    return (
      <HeaderWrapper>
        <ListingWrapper>
          {listingDetails.live &&
            listingDetails.public_status === PublicStatusEnum.Draft && (
              <span>This listing is currently private</span>
            )}
          {((listingDetails.networks && !!listingDetails.networks.length) ||
            listingDetails.visibility === VisibilityEnum.Public) && (
            <Text fontSize={2} fontWeight='bold'>
              Currently listed in
            </Text>
          )}

          <ListedList>
            {listingDetails.public_status !== PublicStatusEnum.Draft && (
              <li>Agora Marketplace ({listingDetails.public_status})</li>
            )}
            {listingDetails.networks &&
              !!listingDetails.networks.length &&
              getListOfNetworks({ networks: listingDetails.networks }).map(
                (network) => <li key={network.id}>{network.name}</li>
              )}
          </ListedList>
        </ListingWrapper>

        <Button size='small' onClick={openListingVisibilityDialog}>
          Update
        </Button>
        <UpdateListingVisibilityDialog
          isOpen={isListingVisibilityOpen}
          onClose={closeListingVisibilityDialog}
          listingDetails={listingDetails}
        />
      </HeaderWrapper>
    );
  } else {
    return <></>;
  }
}

export default ListingAction;
